export default class CommonUtil {
  static getType(value) {
    const typeString = Object.prototype.toString.call(value).slice(8, -1);
    return typeString.toLowerCase();
  }
  static groupClass(...classList) {
    const classListSet = new Set();
    Array.from(classList).forEach((className) => {
      const classNameType = this.getType(className);
      if (classNameType === "string") {
        classListSet.add(className);
      } else if (classNameType === "array") {
        classListSet.add(this.groupClass(...className));
      } else if (classNameType === "object") {
        Object.keys(className).forEach((classKey) => {
          const classValue = className[classKey];
          const classValueType = this.getType(classValue);
          if (classValueType !== "boolean") return;
          if (classValue) {
            classListSet.add(classKey);
          } else {
            classListSet.delete(classKey);
          }
        });
      }
    });

    return Array.from(classListSet).join(" ");
  }
  static pxToRemString(pxValue) {
    if (pxValue === undefined) return "";
    if (this.getType(pxValue) !== "number" || isNaN(pxValue))
      return pxValue.toString();
    const EXCHANGE_COST = 16;
    const remValue = pxValue / EXCHANGE_COST;

    return `${remValue}rem`;
  }

  // Rounded the max to next multiple of ten (nextMax), and create an array of numberthat starts with min,
  // ends with nextMax, has the length of length and each number difference by the same step
  static createNumberRange(min, max, length) {
    const nextMaxMultipleOfTen = Math.ceil(max / 10) * 10;
    const prevMinMultipleOfTen = Math.floor(min / 10) * 10;
    const step = (nextMaxMultipleOfTen - prevMinMultipleOfTen) / (length - 1);

    const range = [];
    for (let index = 0; index < length; index++) {
      range.push(prevMinMultipleOfTen + index * step);
    }
    return range;
  }

  static getDataSearchKey(key, option, isLowerCase = false) {
    if (option === undefined) return "";
    if (option[key] === undefined || option[key] === null) return "";
    if (isLowerCase === true)
      return option[key]?.toString().toLowerCase() ?? "";
    return option[key]?.toString() ?? "";
  }
  static checkFilter(filterList, filterKey) {
    const validFilterList = filterList.filter(
      (item) => item[filterKey] !== null && item[filterKey] !== undefined
    );

    return validFilterList.length > 0;
  }

  static debounce(func, delay) {
    let timeoutId;
    return (...args) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }
}
